// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { capabilities, checkNameAvailability } from "./operations.js";
export type {
  RecoveryServicesCapabilitiesOptionalParams,
  RecoveryServicesCheckNameAvailabilityOptionalParams,
} from "./options.js";
